import track from "../lib/tracking"
export function updateAllInformation(data){
  return {
    type: "UPDATE_ALL_INFORMATION",
    data
  };
}
export function toggleView(destination) {
  track("navigation",{page: destination})
  if(destination === "results"){
    track("get_results");
  }
  window.gtag &&
    window.gtag("event", "changed_view", {
      value: destination,
      eventLabel: "navigation"
    });

  return {
    type: "TOGGLE_VIEW",
    destination
  };
}

export function addLocation(location) {
  window.gtag && window.gtag("event", "added_location");

  return {
    type: "ADD_LOCATION",
    location
  };
}

export function removeLocation(location) {
  window.gtag && window.gtag("event", "removed_location");

  return {
    type: "REMOVE_LOCATION",
    location
  };
}

export function addTarget(value, indexa, indexb) {
  window.gtag && window.gtag("event", "added_target");

  return {
    type: "ADD_TARGET",
    value,
    indexa,
    indexb
  };
}

export function removeTarget(value, index) {
  window.gtag && window.gtag("event", "removed_target");

  return {
    type: "REMOVE_TARGET",
    value,
    index
  };
}
export function cleanTargets() {
  return {
    type: "CLEAN_TARGETS"
  };
}

export function replaceTargets(
  dragIndexa,
  dragIndexb,
  hoverIndexa,
  hoverIndexb
) {
  return {
    type: "REPLACE_TARGETS",
    dragIndexa,
    dragIndexb,
    hoverIndexa,
    hoverIndexb
  };
}

export function setAgeRange(range) {
  window.gtag && window.gtag("event", "changed_age_range");

  return {
    type: "SET_AGE_RANGE",
    range
  };
}

export function setTotals(value) {
  return {
    type: "SET_TOTALS",
    value
  };
}

export function addResult(result) {
  return {
    type: "ADD_RESULT",
    result
  };
}

export function resetResults() {
  return {
    type: "RESET_RESULTS"
  };
}



// WEBPACK FOOTER //
// ./src/actions/index.js